import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Context
import { AuthProvider } from "@/context/AuthContext";

// Kiosk Pages
import KioskHome from "@/pages/kiosk/KioskHome";
import KioskIdentify from "@/pages/kiosk/KioskIdentify";
import KioskAppointments from "@/pages/kiosk/KioskAppointments";
import KioskCheckin from "@/pages/kiosk/KioskCheckin";
import KioskReschedule from "@/pages/kiosk/KioskReschedule";
import KioskSuccess from "@/pages/kiosk/KioskSuccess";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminUsers from "@/pages/admin/AdminUsers";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Kiosk Routes */}
            <Route path="/" element={<KioskHome />} />
            <Route path="/identify/:action" element={<KioskIdentify />} />
            <Route path="/appointments/:action" element={<KioskAppointments />} />
            <Route path="/checkin/:appointmentId" element={<KioskCheckin />} />
            <Route path="/reschedule/:appointmentId" element={<KioskReschedule />} />
            <Route path="/success/:type" element={<KioskSuccess />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <ProtectedRoute>
                  <AdminSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
